import React, { useEffect, useState } from "react";
import "../../css/Features.css";

import { RiSecurePaymentFill, RiAttachmentFill } from "react-icons/ri";
import { FaDatabase } from "react-icons/fa";
import { BsDatabaseFillLock } from "react-icons/bs";

// IMPORT IMAGES FROM src/assets
import img1 from "../../../assets/price/Minimalist.gif";
import img2 from "../../../assets/price/AlternateImage.jpg";

function Features() {
  const [imageSrc, setImageSrc] = useState(img1);

  useEffect(() => {
    const timer = setTimeout(() => {
      setImageSrc(img2);
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="features-container">

      <div className="features-grid">

        {/* LEFT */}
        <div className="features-left">
          <h1>
            Powerful Mobile Testing - Built for Agile Teams
          </h1>

          <p>
            The <span className="highlight">Froth TestOps</span> Mobile App should be your go-to tool for carrying out the entire testing lifecycle of a project. You are capable of executing test cases, logging defects, collaborating with your team, and being in the loop with your projects all through any device and at any time.
          </p>

          {/* FEATURES */}
          <div className="features-cards">

            <div className="feature-card">
              <div className="feature-header">
                <RiSecurePaymentFill className="icon" />
                <h6>Secure Sync</h6>
              </div>
              <b>Unified Testing Across Devices</b>
              <p>
                All testing data of a user are immediately updated between mobile and web versions thus permitting the user to be always in harmony and to have data of high quality across the platforms.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-header">
                <FaDatabase className="icon" />
                <h6>Shake-to-Report</h6>
              </div>
              <b>Easily log bugs directly from your phone</b>
              <p>
                Initiate a bug report in a minute, if not less, with a very few steps and the device in hand—thus Without any problems or interruptions and with the consideration of a tester on the move.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-header">
                <BsDatabaseFillLock className="icon" />
                <h6>All Your Testing Data, Organized</h6>
              </div>
              <b>Complete Listings</b>
              <p>
                Have at your fingertips a complete directory of test cases, scenarios, and also defects whereby all three have been streamlined into a single interface.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-header">
                <RiAttachmentFill className="icon" />
                <h6>Real-Time Attachments</h6>
              </div>
              <b>Real-Time Attachments</b>
              <p>
                Take the screenshot, get the log, or simply have the file and then upload it straight from your phone and at the same time attach it to either a test case or a defect that is going ​‍​‌‍​‍‌​‍​‌‍​‍‌on
              </p>
            </div>

          </div>
        </div>

        {/* RIGHT */}
        <div className="features-right">
          <div className="image-box">
            <img src={imageSrc} alt="Mobile App" />
          </div>
        </div>

      </div>

    </div>
  );
}

export default Features;